export const documentVisibilityDefinition: Record<
  `${boolean}`,
  { label: string }
> = {
  ['false']: { label: 'Customer facing' },
  ['true']: { label: 'Internal document' },
};
